import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { when } from 'mobx'
import { observer, inject } from 'mobx-react'

@inject(['auth'])
@observer
class PasswordResetForm extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    }

    state = {
        error: false,
        processing: false
    }

    componentWillMount() {
        const { location: { state } } = this.props

        this.authWatcher = when(
            () => this.props.auth.resetSent,
            () => this.context.router.push(state && state.return_to || { pathname: '/login/password-reset/success' })
        )
    }

    componentWillUnmount() {
        this.authWatcher()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.setState({ error: false, processing: true })

        const reset_token = this.props.params.reset_token
        const password = this.password.value
        const password_confirmation = this.password_confirmation.value

        if (password != password_confirmation) {
            this.setState({ error: true, processing: false })
        } else {
            this.props.auth.passwordReset(reset_token, password, password_confirmation)
            .catch(() => { this.setState({ error: true, processing: false })})
        }
    }

    render() {
        let errorMessage = this.state.error && <div className="error">Passwords should match</div>

        return (
            <div className="container auth">
                <div className="dialog login" style={{textAlign: 'center'}}>
                    <h3>Reset Your Admin Password</h3>
                    <p>Please enter a new password below and enter it again to confirm your new password.</p>
                    <form onSubmit={this.handleSubmit}>
                        {errorMessage}
                        <div className="form-section">
                            <label htmlFor="password"  style={{ textAlign: 'left' }}>New Password</label>
                            <input type="password" id="password" title="New Password" ref={r => this.password = r} required />
                        </div>
                        <div className="form-section">
                            <label htmlFor="password_confirmation" style={{ textAlign: 'left' }}>Confirm New Password</label>
                            <input type="password" id="password_confirmation" title="Confirm New Password" ref={r => this.password_confirmation = r} required />
                        </div>
                        <button type="submit" disabled={this.state.processing}>
                            Reset My Password
              <div className="bounceloader">
                                <div className="bounce1"></div>
                                <div className="bounce2"></div>
                                <div className="bounce3"></div>
                            </div>
                        </button>
                    </form>
                </div>
            </div>
        )
    }
}

export default PasswordResetForm



// WEBPACK FOOTER //
// client/components/auth/PasswordResetForm.js